import { Controller } from "@hotwired/stimulus"

// Debounces and auto-submits the controller's form via fetch + Turbo Streams.
// Uses fetch() rather than form.requestSubmit() because firing the form's submit
// event can cause the browser/Turbo to shift focus back onto the submitting form.
//
// Attach to a <form> element with `data-controller="auto-save"`.
// Wire inputs with e.g. `data-action="blur->auto-save#submit"`.
export default class extends Controller {
  static values = { debounce: { type: Number, default: 250 } }

  initialize() {
    this.timer = null
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  submit() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => this.send(), this.debounceValue)
  }

  async send() {
    const form = this.element
    const formData = new FormData(form)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken || "",
        },
        body: formData,
        credentials: "same-origin",
      })

      const html = await response.text()
      if (response.ok && html && window.Turbo?.renderStreamMessage) {
        window.Turbo.renderStreamMessage(html)
      }
    } catch (e) {
      console.error("auto-save failed", e)
    }
  }
}
